/* Richard Galo cart drawer controller (Dawn contract, no jQuery, safe to load twice) */
(function () {
  if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.bindOverlay();
      this.setHeaderCartIconAccessibility();
    }

    bindOverlay() {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay && !overlay.dataset.rgBound) {
        overlay.dataset.rgBound = '1';
        overlay.addEventListener('click', this.close.bind(this));
      }
    }

    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink) return;
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }

    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
      setTimeout(() => {
        this.classList.add('animate', 'active');
      });
      this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('CartDrawer');
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          if (typeof trapFocus === 'function' && containerToTrapFocusOn) trapFocus(containerToTrapFocusOn, focusElement);
        },
        { once: true }
      );
      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.classList.remove('active');
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
    }

    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');
      if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
        cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
      }
      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      });
      if (typeof onKeyUpEscape === 'function') cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    renderContents(parsedState) {
      this.classList.remove('is-empty');
      const inner = this.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (!sectionElement || !parsedState.sections || !parsedState.sections[section.id]) return;
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      });
      setTimeout(() => {
        this.bindOverlay();
        this.open();
      });
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
      return [
        { id: 'cart-drawer', selector: '#CartDrawer' },
        { id: 'cart-icon-bubble' },
      ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  customElements.define('cart-drawer', CartDrawer);
  }

  function defineItems() {
    if (customElements.get('cart-drawer-items') || typeof CartItems === 'undefined') return false;
    class CartDrawerItems extends CartItems {
      getSectionsToRender() {
        return [
          { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
          { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
        ];
      }
    }
    customElements.define('cart-drawer-items', CartDrawerItems);
    return true;
  }
  /* cart.js may load after this file; keep trying until CartItems exists */
  if (!defineItems()) {
    document.addEventListener('DOMContentLoaded', defineItems);
    window.addEventListener('load', defineItems);
  }
})();
